import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import ProfileSidebar from '../components/profile/ProfileSidebar';
import { defaultLanguage, languageOptions } from '../constants/languages';
import {
  getUserSession,
  mergeSessionUser,
  saveUserSession,
} from '../services/authService';
import { resolveUserLanguage, saveUserLanguage } from '../services/languageService';
import '../styles/profile.css';

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M5 12l4 4 10-10" />
  </svg>
);

const ProfileLanguagePage = () => {
  const sessionUser = getUserSession();
  const sessionUserId = sessionUser ? sessionUser.id : null;
  const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    setSelectedLanguage(resolveUserLanguage(getUserSession()));
  }, [sessionUserId]);

  if (!sessionUser) {
    return <Redirect to="/iniciar-sesion" />;
  }

  if (sessionUser.tipo === 'paciente') {
    return <Redirect to="/perfil" />;
  }

  const handleSave = () => {
    setIsSaving(true);
    setErrorMessage('');
    setMessage('');

    saveUserLanguage(sessionUserId, selectedLanguage)
      .then((result) => {
        const updatedSession = mergeSessionUser({ idioma: result.idioma || selectedLanguage });
        if (updatedSession) {
          saveUserSession(updatedSession);
        }
        setMessage('Idioma guardado correctamente.');
      })
      .catch((error) => {
        setErrorMessage(error.message || 'No se pudo guardar el idioma.');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  return (
    <div className="profile-root">
      <div className="profile-layout">
        <ProfileSidebar activeId="language" />

        <section className="profile-main">
          <h1 className="profile-language-title">Elige tu Idioma</h1>

          <div className="profile-language-grid">
            {languageOptions.map((option) => {
              const isSelected = selectedLanguage === option.code;

              return (
                <button
                  key={option.code}
                  type="button"
                  className={`profile-language-card${isSelected ? ' profile-language-card--selected' : ''}`}
                  onClick={() => {
                    setSelectedLanguage(option.code);
                    setMessage('');
                    setErrorMessage('');
                  }}
                  aria-pressed={isSelected}
                >
                  {isSelected ? (
                    <span className="profile-language-check" aria-hidden="true">
                      <CheckIcon />
                    </span>
                  ) : null}
                  <span className="profile-language-flag" aria-hidden="true">
                    {option.flag}
                  </span>
                  <span className="profile-language-label">{option.label}</span>
                </button>
              );
            })}
          </div>

          {errorMessage ? <p className="profile-status profile-status--error">{errorMessage}</p> : null}
          {message ? <p className="profile-status">{message}</p> : null}

          <div className="profile-language-actions">
            <button
              type="button"
              className="profile-language-save"
              onClick={handleSave}
              disabled={isSaving}
            >
              {isSaving ? 'Guardando...' : 'Guardar cambios >'}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProfileLanguagePage;
